// South African Rand currency formatting

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R 0.00';
  
  const formatted = new Intl.NumberFormat('en-ZA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  
  return `R ${formatted}`;
};

export const parseCurrency = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return 0;
  
  // Remove R symbol, spaces, and any non-numeric characters except decimal point
  const cleaned = value.replace(/[R\s,]/g, '');
  const parsed = parseFloat(cleaned);
  
  return isNaN(parsed) ? 0 : parsed;
};

// Format phone number to +27 21 123 4567 format
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-numeric characters
  let cleaned = phone.replace(/\D/g, '');
  
  // Handle South African numbers
  if (cleaned.startsWith('27')) {
    // Already has country code
  } else if (cleaned.startsWith('0')) {
    // Replace leading 0 with 27
    cleaned = '27' + cleaned.substring(1);
  } else if (cleaned.length === 9) {
    // Missing leading 0, add country code
    cleaned = '27' + cleaned;
  }
  
  // Format as +27 XX XXX XXXX
  if (cleaned.length >= 11) {
    const countryCode = cleaned.substring(0, 2);
    const areaCode = cleaned.substring(2, 4);
    const part1 = cleaned.substring(4, 7);
    const part2 = cleaned.substring(7, 11);
    return `+${countryCode} ${areaCode} ${part1} ${part2}`;
  } else if (cleaned.length >= 9) {
    // Shorter format
    const countryCode = cleaned.substring(0, 2);
    const rest = cleaned.substring(2);
    const formatted = rest.replace(/(\d{2})(\d{3})(\d+)/, '$1 $2 $3');
    return `+${countryCode} ${formatted}`;
  }
  
  return phone; // Return original if can't format
};

// Parse phone number - strip formatting for storage
export const parsePhoneNumber = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

// Format number with thousand separators
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '';
  return new Intl.NumberFormat('en-ZA', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};

// Parse formatted number back to float
export const parseNumber = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return 0;
  const cleaned = value.replace(/[^\d.-]/g, '');
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
};

export const CURRENCY_SYMBOL = 'R';
export const CURRENCY_CODE = 'ZAR';
